import { render } from "./UnitInfo.vue?vue&type=template&id=1e8b466b&scoped=true"
import script from "./UnitInfo.vue?vue&type=script&lang=js"
export * from "./UnitInfo.vue?vue&type=script&lang=js"

import "./UnitInfo.vue?vue&type=style&index=0&id=1e8b466b&lang=less&scoped=true"

import exportComponent from "C:\\IdeaProjects\\frontEnd\\gdstiweb\\node_modules\\.pnpm\\registry.npmmirror.com+vue-loader@16.8.3_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@4.47.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e8b466b"]])

export default __exports__